import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';

export class AuditReportModel {
  resources: BaseProviderInstanceResourceModel[];
  beginDate: Date;
  endDate: Date;
}
